import type { ReactNode } from "react";
import { cx } from "./cx";

export type StatCardTone = "ok" | "warn" | "danger";

export interface StatCardProps {
  label: ReactNode;
  value: ReactNode;
  /** Muted description line under the value. */
  sub?: ReactNode;
  /** Tints the value with the design system's status colours. */
  tone?: StatCardTone;
}

export function StatCard({ label, value, sub, tone }: StatCardProps) {
  return (
    <div className="stat-card">
      <div className="label">{label}</div>
      <div className={cx("value", tone)}>{value}</div>
      {sub != null && <p>{sub}</p>}
    </div>
  );
}
